/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
"use strict";
var lang_1 = require('./lang');
exports.Math = lang_1.global.Math;
exports.NaN = typeof exports.NaN;
//# sourceMappingURL=math.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@angular/core/src/facade/math.js
 ** module id = 109
 ** module chunks = 2
 **/